import { countryCodeEmoji } from "country-code-emoji";
import { getCodeList } from "country-list";
import {
  getCountries,
  getCountryCallingCode as _getCountryCallingCode
} from "libphonenumber-js";

const availableISOCodes = getCountries();

const availableCountryNames = getCodeList();

const getCountryCallingCode = countryISOCode =>
  _getCountryCallingCode(countryISOCode.toUpperCase());

const getCountryName = countryISOCode =>
  availableCountryNames[countryISOCode.toLowerCase()];

const getCountryFlagEmoji = countryISOCode => countryCodeEmoji(countryISOCode);

const getCountryISOCode = countryISOCode => countryISOCode.toUpperCase();

const getSupportableISOCodes = countryISOCodeArray =>
  countryISOCodeArray.filter(
    ISOCode => availableCountryNames[ISOCode.toLowerCase()]
  );

const getCountryData = (countryISOCodeArray = []) => {
  const countryISOCodes = countryISOCodeArray.length
    ? countryISOCodeArray
    : availableISOCodes;

  const supportableISOCodes = getSupportableISOCodes(countryISOCodes).sort(
    (a, b) => (getCountryName(a) < getCountryName(b) ? -1 : 1) // alphabetize by country name
  );

  return supportableISOCodes.reduce((acc, ISOCode) => {
    const countryName = getCountryName(ISOCode);
    const countryCallingCode = getCountryCallingCode(ISOCode);
    const countryFlagEmoji = getCountryFlagEmoji(ISOCode);
    const countryISOCode = getCountryISOCode(ISOCode);

    acc[countryISOCode] = {
      countryISOCode,
      countryName,
      countryCallingCode,
      countryFlagEmoji
    };

    return acc;
  }, {});
};

export default getCountryData;
